import React from "react";
import {
	DashboardOutlined,
	PlusOutlined,
	InfoOutlined,
	KeyOutlined,
	TeamOutlined,
	CarOutlined,
	UserOutlined,
	ShopOutlined,
	PictureOutlined,
	UserSwitchOutlined,
	ReadOutlined,
	GatewayOutlined,
	TransactionOutlined,
	ApartmentOutlined,
	SettingOutlined,
	MenuOutlined,
	QuestionOutlined,
	NotificationOutlined,
	ExceptionOutlined,
	DeploymentUnitOutlined,
	UsergroupAddOutlined,
	EuroCircleOutlined,
	GlobalOutlined,
	FormOutlined,
	GiftOutlined,
	TrophyOutlined,
	PlayCircleOutlined,
	MobileOutlined,
	AppstoreOutlined,
	BookOutlined,
	DesktopOutlined,
	FileOutlined,
	EditOutlined,
} from "@ant-design/icons";
import { RouteEl } from "types";

import BookServiceDetail from "features/book-service/BookServiceDetail";

import { PERMISSION } from "../constants";
import { APP_PATH } from "./../constants/path";
import CarCreate from "features/cars/create";
import { ENV_MODE } from "constants/constants";
import { lazyRetry } from "utils/route";
import RatingRoutes from "./rating";
import materDataRoutes from "./master-data";
import HotSaleRoutes from "./hot-sale";
import Investments from "features/webapp/investment";
import auctionRoutes from "./auction";
import SubscriptionPackages from "features/subscription-class";
import SubscriptionClassDetail from "features/subscription-class/detail/SubscriptionClassDetail";
import transactionRoutes from "./transaction";
import SurveyDetail from "features/survey/detail/SurveyDetail";
import RequestServiceRoutes from "./request-service";
import affiliateRoutes from "./affiliate";
import supercarRoutes from "./supercar";
import carCareRoutes from "./CarCare";
import investmentRoutes from "./investment";

const CareerPosts = React.lazy(() =>
	lazyRetry(() => import("../features/webapp/recruitment/career-posts")),
);
const CareerPostDetail = React.lazy(() =>
	lazyRetry(
		() =>
			import("../features/webapp/recruitment/career-posts/CareerPostDetail"),
	),
);

const Candidates = React.lazy(() =>
	lazyRetry(() => import("../features/webapp/recruitment/candidates")),
);

const CandidateDetail = React.lazy(() =>
	lazyRetry(
		() => import("../features/webapp/recruitment/candidates/CandidateDetail"),
	),
);

const CarDetail = React.lazy(() =>
	lazyRetry(() => import("../features/cars/detail")),
);
const CarList = React.lazy(() => lazyRetry(() => import("../features/cars")));
const Dashboard = React.lazy(() =>
	lazyRetry(() => import("../features/dashboard")),
);

// My account
const MyAccount = React.lazy(() =>
	lazyRetry(() => import("../features/my-account/MyAccount")),
);

// Staff
const Staffs = React.lazy(() =>
	lazyRetry(() => import("../features/staff/StaffList")),
);
const StaffCreate = React.lazy(() =>
	lazyRetry(() => import("../features/staff/StaffCreate")),
);
const StaffDetail = React.lazy(() =>
	lazyRetry(() => import("../features/staff/StaffDetail")),
);
const Decentralization = React.lazy(() =>
	// lazyRetry(() => import("../features/decentralization/Decentralization")),
	lazyRetry(
		() => import("../features/decentralization/ImprovedDecentralization"),
	),
);

// Sale Staff
const SaleStaffs = React.lazy(() =>
	lazyRetry(() => import("../features/sale-staffs/SaleStaffList")),
);

const SaleStaffDetail = React.lazy(() =>
	lazyRetry(() => import("../features/sale-staffs/SaleStaffDetail")),
);
// Role
const Roles = React.lazy(() =>
	lazyRetry(() => import("../features/role/RoleList")),
);
const RoleCreate = React.lazy(() =>
	lazyRetry(() => import("../features/role/RoleCreate")),
);
const RoleDetail = React.lazy(() =>
	lazyRetry(() => import("../features/role/RoleDetail")),
);

//Merchant
const Merchants = React.lazy(() =>
	lazyRetry(() => import("../features/merchant/MerchantList")),
);
const MerchantCreate = React.lazy(() =>
	lazyRetry(() => import("../features/merchant/MerchantCreate")),
);
const MerchantDetail = React.lazy(() =>
	lazyRetry(() => import("../features/merchant/MerchantDetail")),
);

const StoreList = React.lazy(() =>
	lazyRetry(() => import("../features/store/StoreList")),
);
// Merchant stores
const StoreDetail = React.lazy(() =>
	lazyRetry(() => import("../features/store/StoreDetail")),
);

// Merchant Carpart
const CarPartDetail = React.lazy(() =>
	lazyRetry(() => import("../features/merchant/tabs/carParts/Detail")),
);

// Merchant billing infor
const BillingInforDetail = React.lazy(() =>
	lazyRetry(
		() =>
			import(
				"../features/merchant/tabs/subscription-billing-infor/SubscriptionBillingInforDetail"
			),
	),
);

// Car care detail
const CarCareDetail = React.lazy(() =>
	lazyRetry(() => import("../features/car-care/CarCareDetail")),
);

// Banner
const AppHorizontalBanner = React.lazy(() =>
	lazyRetry(() => import("../features/banner/APP/horizontal")),
);

const WebAppHorizontalBanner = React.lazy(() =>
	lazyRetry(() => import("../features/banner/WEBAPP/horizontal")),
);
const WebAppVerticalBanner = React.lazy(() =>
	lazyRetry(() => import("../features/banner/WEBAPP/vertical")),
);
const AppHorizontalBannerDetail = React.lazy(() =>
	lazyRetry(
		() => import("../features/banner/APP/horizontal/AppHorizontalBannerDetail"),
	),
);
// Customer
const Customers = React.lazy(() =>
	lazyRetry(() => import("../features/customer/CustomerList")),
);
const CustomerCreate = React.lazy(() =>
	lazyRetry(() => import("../features/customer/CustomerCreate")),
);
const CustomerDetail = React.lazy(() =>
	lazyRetry(() => import("../features/customer/CustomerDetail")),
);

// Service
const Services = React.lazy(() =>
	lazyRetry(() => import("../features/service/ServiceList")),
);
const ServiceCreate = React.lazy(() =>
	lazyRetry(() => import("../features/service/ServiceCreate")),
);
const ServiceDetail = React.lazy(() =>
	lazyRetry(() => import("../features/service/ServiceDetail")),
);

const ServiceCategory = React.lazy(() =>
	lazyRetry(() => import("../features/service-category/ServiceCategoryList")),
);
const ServiceCategoryCreate = React.lazy(() =>
	lazyRetry(() => import("../features/service-category/ServiceCategoryCreate")),
);
const ServiceCategoryDetail = React.lazy(() =>
	lazyRetry(() => import("../features/service-category/ServiceCategoryDetail")),
);

const News = React.lazy(() =>
	lazyRetry(() => import("../features/news/NewsList")),
);
const NewsInformation = React.lazy(() =>
	lazyRetry(() => import("../features/news/NewsInformation")),
);

const Popup = React.lazy(() => import("../features/popup"));
const PopupCreate = React.lazy(() => import("../features/popup/PopupCreate"));

// end config components

// survey answer
const SurveyAnswers = React.lazy(() =>
	lazyRetry(() => import("../features/survey-answer/SurveyList")),
);

// Notifications-manager
const NotificationList = React.lazy(() =>
	lazyRetry(() => import("../features/notification-manage")),
);
const NotificationCreate = React.lazy(() =>
	lazyRetry(() => import("../features/notification-manage/NotificationCreate")),
);

const AnnouncementList = React.lazy(() =>
	lazyRetry(() => import("../features/announcement")),
);
const AnnouncementCreate = React.lazy(() =>
	lazyRetry(() => import("../features/announcement/AnnouncementCreate")),
);

const ContactSupports = React.lazy(() =>
	lazyRetry(() => import("../features/request-services/contact-support")),
);
const ContactSupport = React.lazy(() =>
	lazyRetry(
		() =>
			import(
				"../features/request-services/contact-support/components/ContactSupport"
			),
	),
);

const Surveys = React.lazy(() => lazyRetry(() => import("../features/survey")));

const AppVersion = React.lazy(() =>
	lazyRetry(() => import("../features/app-version")),
);

const CommunityPosts = React.lazy(() =>
	lazyRetry(() => import("../features/community/post")),
);
const CommunityPost = React.lazy(() =>
	lazyRetry(() => import("../features/community/post/components/Post")),
);

const LoyaltyCampaigns = React.lazy(() =>
	lazyRetry(() => import("../features/loyalty/campaign")),
);

const LoyaltyCampaign = React.lazy(() =>
	lazyRetry(() => import("../features/loyalty/campaign/components/Detail")),
);

const LoyaltyCustomerVoucherOfLiberty = React.lazy(() =>
	lazyRetry(
		() => import("../features/loyalty/voucher/customer/VoucherOfLiberty"),
	),
);

const LoyaltyCustomerVoucherOfMerhant = React.lazy(() =>
	lazyRetry(
		() => import("../features/loyalty/voucher/customer/VoucherOfMerchant"),
	),
);

const LoyaltyVoucher = React.lazy(() =>
	lazyRetry(() => import("../features/loyalty/voucher/component/Voucher")),
);
const LoyaltyVouchersMerchant = React.lazy(() =>
	lazyRetry(() => import("../features/loyalty/voucher/merchant")),
);

// WebApp
const FormRequestDetail = React.lazy(() =>
	lazyRetry(() => import("../features/webapp/form-request/FormRequestDetail")),
);

const CarPartList = React.lazy(() =>
	lazyRetry(() => import("../features/merchant/tabs/carParts")),
);
const routes: RouteEl[] = [
	{
		label: "Dashboard",
		path: APP_PATH.dashboard,
		key: "dashboard",
		icon: <DashboardOutlined />,
		children: [],
		component: <Dashboard />,
	},
	// My account
	{
		label: "My account",
		path: APP_PATH.myAccount,
		key: "my-account",
		icon: <UserOutlined />,
		children: [],
		component: <MyAccount />,
		hidden: true,
	},

	// start staff
	{
		label: "Staffs",
		path: "",
		key: "staffs",
		icon: <TeamOutlined />,
		children: [
			{
				label: "Staffs",
				path: APP_PATH.staffs,
				key: "staffs-list",
				icon: <TeamOutlined />,
				children: [],
				component: <Staffs />,
				permissions: [PERMISSION.STAFF.VIEW],
			},
			{
				label: "Create staff",
				path: APP_PATH.staffCreate,
				key: "",
				icon: <PlusOutlined />,
				children: [],
				component: <StaffCreate />,
				hidden: true,
				permissions: [PERMISSION.STAFF.CREATE],
			},
			{
				label: "Staff detail",
				path: `${APP_PATH.staffs}/:id`,
				key: "",
				icon: <InfoOutlined />,
				children: [],
				component: <StaffDetail />,
				hidden: true,
				permissions: [PERMISSION.STAFF.VIEW],
			},
			{
				label: "Sale Staffs",
				path: APP_PATH.saleStaffs,
				key: "staffs-sales",
				icon: <TeamOutlined />,
				children: [],
				component: <SaleStaffs />,
				permissions: [PERMISSION.STAFF.VIEW],
			},
			{
				label: "Create Sale Staffs",
				path: APP_PATH.saleStaffCreate,
				key: "",
				icon: <TeamOutlined />,
				children: [],
				component: <SaleStaffDetail />,
				hidden: true,
				permissions: [PERMISSION.STAFF.UPDATE],
			},
			{
				label: "Sale Staff Details",
				path: `${APP_PATH.saleStaffs}/:id`,
				key: "",
				icon: <TeamOutlined />,
				children: [],
				component: <SaleStaffDetail />,
				hidden: true,
				permissions: [PERMISSION.STAFF.UPDATE],
			},
			{
				label: "Decentralization",
				path: APP_PATH.staffDecentralization,
				key: "staffs-decentralization",
				icon: <ApartmentOutlined />,
				children: [],
				component: <Decentralization />,
				permissions: [PERMISSION.ROLE.VIEW],
			},
			{
				label: "Roles",
				path: APP_PATH.staffRoles,
				key: "staffs-roles",
				icon: <KeyOutlined />,
				children: [],
				component: <Roles />,
				permissions: [PERMISSION.ROLE.VIEW],
			},
			{
				label: "Create role",
				path: APP_PATH.staffRolesCreate,
				key: "",
				icon: <PlusOutlined />,
				children: [],
				component: <RoleCreate />,
				hidden: true,
				permissions: [PERMISSION.ROLE.CREATE],
			},
			{
				label: "Role detail",
				path: `${APP_PATH.staffRoles}/:id`,
				key: "",
				icon: <InfoOutlined />,
				children: [],
				component: <RoleDetail />,
				hidden: true,
				permissions: [PERMISSION.ROLE.VIEW],
			},
		],
	},
	// end staff

	// CRM
	{
		label: "CRM",
		path: "",
		key: "crm",
		icon: <TeamOutlined />,
		children: [
			{
				label: "Merchants",
				path: "",
				key: "merchants",
				icon: <ShopOutlined />,
				children: [
					{
						label: "Merchants",
						path: APP_PATH.merchants,
						key: "merchantsList",
						icon: <ShopOutlined />,
						children: [],
						component: <Merchants />,
						permissions: [PERMISSION.MERCHANT.VIEW],
					},
					{
						label: "Create merchant",
						path: APP_PATH.merchantCreate,
						key: "",
						icon: <PlusOutlined />,
						children: [],
						component: <MerchantCreate />,
						hidden: true,
						permissions: [PERMISSION.MERCHANT.CREATE],
					},
					{
						label: "Merchant detail",
						path: `${APP_PATH.merchants}/:id`,
						key: "merchantDetail",
						icon: <InfoOutlined />,
						children: [],
						component: <MerchantDetail />,
						hidden: true,
						permissions: [PERMISSION.MERCHANT.VIEW],
					},
					{
						label: "Car part detail",
						path: `${APP_PATH.merchants}/:id/car-part/:carPartId`,
						key: "merchantCarPartDetail",
						icon: <InfoOutlined />,
						children: [],
						component: <CarPartDetail />,
						hidden: true,
						permissions: [PERMISSION.MERCHANT.VIEW],
					},
					{
						label: "Billing infor detail",
						path: `${APP_PATH.merchants}/:merchantId/billing-infor/:billId`,
						key: "",
						icon: <InfoOutlined />,
						children: [],
						component: <BillingInforDetail />,
						hidden: true,
						permissions: [PERMISSION.MERCHANT.VIEW],
					},
					{
						label: "Car care detail",
						path: `${APP_PATH.merchants}/:merchantId/car-care/:carCareId`,
						key: "",
						icon: <InfoOutlined />,
						children: [],
						component: <CarCareDetail />,
						hidden: true,
						permissions: [PERMISSION.MERCHANT.VIEW],
					},
					{
						label: "Stores",
						path: APP_PATH.stores,
						key: "car-stores",
						icon: <ShopOutlined />,
						children: [],
						component: <StoreList outsideMerchantDetails />,
						permissions: [PERMISSION.CAR_STORE.VIEW],
					},
					{
						label: "Store Detail",
						path: `${APP_PATH.stores}/:id`,
						key: "car-stores detail",
						icon: <ShopOutlined />,
						children: [],
						component: <StoreDetail />,
						hidden: true,
						permissions: [
							PERMISSION.CAR_STORE.UPDATE,
							PERMISSION.CAR_STORE.VIEW,
						],
					},
					{
						label: "Create",
						path: `${APP_PATH.stores}/create`,
						key: "car-stores-create",
						icon: <ShopOutlined />,
						children: [],
						component: <StoreDetail />,
						hidden: true,
						permissions: [
							PERMISSION.CAR_STORE.UPDATE,
							PERMISSION.CAR_STORE.VIEW,
						],
					},
					// Cars
					{
						label: "Cars",
						path: APP_PATH.cars,
						key: "cars",
						icon: <CarOutlined />,
						children: [],
						component: <CarList />,
						permissions: [PERMISSION.CAR.VIEW],
					},
					{
						label: "Car Detail",
						path: `${APP_PATH.cars}/:id`,
						key: "cars",
						icon: <CarOutlined />,
						children: [],
						component: <CarDetail />,
						hidden: true,
						permissions: [PERMISSION.CAR.VIEW],
					},
					{
						label: "Create car",
						path: APP_PATH.carCreate,
						key: "cars create",
						icon: <CarOutlined />,
						children: [],
						component: <CarCreate />,
						hidden: true,
						permissions: [PERMISSION.CAR.VIEW],
					},
					{
						label: "Accessories",
						path: `${APP_PATH.carParts}`,
						key: "car-parts",
						icon: <SettingOutlined />,
						children: [],
						component: <CarPartList />,
						permissions: [PERMISSION.CAR.VIEW],
					},
					{
						label: "Accessory detail",
						path: `${APP_PATH.carParts}/:carPartId`,
						key: "cars-detais",
						icon: <SettingOutlined />,
						children: [],
						component: <CarPartDetail />,
						hidden: true,
						permissions: [PERMISSION.CAR.VIEW],
					},
					// Supercars
					...supercarRoutes,
					// car care,
					...carCareRoutes,
				],
			},
			// Merchant

			//Customer
			{
				label: "customer",
				path: APP_PATH.customers,
				key: "customers",
				icon: <UserSwitchOutlined />,
				children: [],
				component: <Customers />,
				permissions: [PERMISSION.CUSTOMER.VIEW],
			},
			{
				label: "Create customer",
				path: APP_PATH.customerCreate,
				key: "",
				icon: <PlusOutlined />,
				children: [],
				component: <CustomerCreate />,
				hidden: true,
				permissions: [PERMISSION.CUSTOMER.CREATE],
			},
			{
				label: "Customer detail",
				path: `${APP_PATH.customers}/:id`,
				key: "",
				icon: <InfoOutlined />,
				children: [],
				component: <CustomerDetail />,
				hidden: true,
				permissions: [PERMISSION.CUSTOMER.VIEW],
			},
		],
	},

	// Config routes
	{
		label: "Config",
		path: "",
		key: "config",
		icon: <SettingOutlined />,
		children: [
			{
				label: "Banner",
				path: "",
				key: "banner",
				icon: <PictureOutlined />,
				children: [
					{
						label: "APP",
						path: "",
						key: "app",
						icon: <MobileOutlined />,
						permissions: [PERMISSION.BANNERS.VIEW],
						children: [
							{
								label: "Horizontal banners",
								path: APP_PATH.appHorizontalBanners,
								key: "horizontal-banners",
								icon: <PictureOutlined />,
								component: <AppHorizontalBanner />,
								permissions: [PERMISSION.BANNERS.VIEW],
							},
							{
								label: "Horizontal banners create",
								path: APP_PATH.appHorizontalBannerCreate,
								key: "horizontal-banners",
								icon: <PictureOutlined />,
								component: <AppHorizontalBannerDetail />,
								permissions: [PERMISSION.BANNERS.VIEW],
								hidden: true,
							},
							{
								label: "Horizontal banners detail",
								path: `${APP_PATH.appHorizontalBanners}/:id`,
								key: "horizontal-banners",
								icon: <PictureOutlined />,
								component: <AppHorizontalBannerDetail />,
								permissions: [PERMISSION.BANNERS.VIEW],
								hidden: true,
							},
						],
					},
					{
						label: "WEBAPP",
						path: "",
						key: "banner-webapp",
						icon: <DesktopOutlined />,
						permissions: [PERMISSION.BANNERS.VIEW],
						children: [
							{
								label: "Horizontal banners",
								path: APP_PATH.webappHorizontalBanners,
								key: "horizontal-banner",
								icon: <PictureOutlined />,
								component: <WebAppHorizontalBanner />,
								permissions: [PERMISSION.BANNERS.VIEW],
							},
							{
								label: "Horizontal banners create",
								path: APP_PATH.webappHorizontalBannerCreate,
								key: "horizontal-banner",
								component: <AppHorizontalBannerDetail />,
								permissions: [PERMISSION.BANNERS.VIEW],
								hidden: true,
							},
							{
								label: "Horizontal banners detail",
								path: `${APP_PATH.webappHorizontalBanners}/:id`,
								key: "horizontal-banner",
								component: <AppHorizontalBannerDetail />,
								permissions: [PERMISSION.BANNERS.VIEW],
								hidden: true,
							},
							{
								label: "Vertical banners",
								path: APP_PATH.webappVerticalBanners,
								key: "vertical-banner",
								icon: <FileOutlined />,
								component: <WebAppVerticalBanner />,
								permissions: [PERMISSION.BANNERS.VIEW],
							},

							{
								label: "Vertical banners create",
								path: APP_PATH.webappVerticalBannerCreate,
								key: "horizontal-banner",
								component: <AppHorizontalBannerDetail />,
								permissions: [PERMISSION.BANNERS.VIEW],
								hidden: true,
							},
							{
								label: "Vertical banners detail",
								path: `${APP_PATH.webappVerticalBanners}/:id`,
								key: "horizontal-banner",
								component: <AppHorizontalBannerDetail />,
								permissions: [PERMISSION.BANNERS.VIEW],
								hidden: true,
							},
						],
					},

					// end banner
				],
			},

			// end popup
			{
				label: "Popups",
				path: APP_PATH.popups,
				key: "popups",
				icon: <PictureOutlined />,
				children: [],
				component: <Popup />,
				permissions: [PERMISSION.POPUP.VIEW],
			},
			{
				label: "Create popup",
				path: APP_PATH.popupCreate,
				key: "",
				icon: <PlusOutlined />,
				children: [],
				component: <PopupCreate />,
				hidden: true,
				permissions: [PERMISSION.POPUP.CREATE],
			},
			{
				label: "Popup Detail",
				path: `${APP_PATH.popups}/:id`,
				key: "",
				icon: <InfoOutlined />,
				children: [],
				component: <PopupCreate />,
				hidden: true,
				permissions: [PERMISSION.POPUP.VIEW],
			},
			// end popup

			// start news
			{
				label: "News",
				path: APP_PATH.news,
				key: "news",
				icon: <ReadOutlined />,
				children: [],
				component: <News />,
				permissions: [PERMISSION.NEWS.VIEW],
			},
			{
				label: "Create news",
				path: APP_PATH.newsCreate,
				key: "",
				icon: <PlusOutlined />,
				children: [],
				component: <NewsInformation />,
				hidden: true,
				permissions: [PERMISSION.NEWS.CREATE],
			},
			{
				label: "News detail",
				path: `${APP_PATH.news}/:id`,
				key: "",
				icon: <InfoOutlined />,
				children: [],
				component: <NewsInformation />,
				hidden: true,
				permissions: [PERMISSION.NEWS.VIEW],
			},
			// end news

			// Start hot sale

			...HotSaleRoutes,

			// end hot sale

			{
				label: "Subscription package",
				path: APP_PATH.subscriptionClass,
				key: "subscription-package",
				icon: <PictureOutlined />,
				component: <SubscriptionPackages />,
				permissions: [PERMISSION.SUBSCRIPTION.VIEW],
			},
			{
				label: "Subscription package",
				path: `${APP_PATH.subscriptionClass}/:id`,
				key: "subscription-package",
				icon: <PictureOutlined />,
				component: <SubscriptionClassDetail />,
				permissions: [PERMISSION.SUBSCRIPTION.VIEW],
				hidden: true,
			},
			{
				label: "Subscription package",
				path: APP_PATH.subscriptionClassCreate,
				key: "subscription-package",
				icon: <PictureOutlined />,
				component: <SubscriptionClassDetail />,
				permissions: [PERMISSION.SUBSCRIPTION.CREATE],
				hidden: true,
			},
			{
				label: "Survey package",
				path: APP_PATH.surveyDetail,
				key: "Survey-package",
				icon: <PictureOutlined />,
				component: <SurveyDetail />,
				permissions: [PERMISSION.SUBSCRIPTION.CREATE],
				hidden: true,
			},
			{
				label: "Survey package",
				path: `${APP_PATH.surveyDetail}/:id`,
				key: "Survey-package",
				icon: <PictureOutlined />,
				component: <SurveyDetail />,
				hidden: true,
			},
		],
		permissions: [],
	},

	// transaction
	{ ...transactionRoutes },

	// Start Service
	{
		label: "Notifications",
		path: "",
		key: "notifications",
		icon: <NotificationOutlined />,
		children: [
			// start announcement
			{
				label: "Announcements",
				path: APP_PATH.announcements,
				key: "announcements",
				icon: <NotificationOutlined />,
				component: <AnnouncementList />,
				permissions: [PERMISSION.NOTIFICATION_SYSTEM.VIEW],
			},
			{
				label: "Announcement create",
				path: APP_PATH.announcementCreate,
				key: "",
				icon: <NotificationOutlined />,
				component: <AnnouncementCreate />,
				permissions: [PERMISSION.NOTIFICATION_SYSTEM.CREATE],
				hidden: true,
			},
			{
				label: "Announcement detail",
				path: `${APP_PATH.announcements}/:id`,
				key: "",
				icon: <NotificationOutlined />,
				component: <AnnouncementCreate />,
				permissions: [PERMISSION.NOTIFICATION_SYSTEM.VIEW],
				hidden: true,
			},
			// end announcement

			// start notification-manage
			{
				label: "Systems",
				path: APP_PATH.notifications,
				key: "systems",
				icon: <NotificationOutlined />,
				component: <NotificationList />,
				permissions: [PERMISSION.NOTIFICATION_SYSTEM.VIEW],
			},
			{
				label: "Systems create",
				path: APP_PATH.notificationCreate,
				key: "",
				icon: <NotificationOutlined />,
				component: <NotificationCreate />,
				permissions: [PERMISSION.NOTIFICATION_SYSTEM.CREATE],
				hidden: true,
			},
			{
				label: "Systems detail",
				path: `${APP_PATH.notifications}/:id`,
				key: "",
				icon: <NotificationOutlined />,
				component: <NotificationCreate />,
				permissions: [PERMISSION.NOTIFICATION_SYSTEM.VIEW],
				hidden: true,
			},
			// end notification-manage
		],
	},

	//Notification
	{
		label: "Services",
		path: "",
		key: "services",
		icon: <TransactionOutlined />,
		children: [
			//Service
			{
				label: "Services",
				path: APP_PATH.services,
				key: "servicesList",
				icon: <GatewayOutlined />,
				children: [],
				component: <Services />,
				permissions: [PERMISSION.SERVICES.VIEW],
			},
			{
				label: "Create service",
				path: APP_PATH.serviceCreate,
				key: "",
				icon: <PlusOutlined />,
				children: [],
				component: <ServiceCreate />,
				hidden: true,
				permissions: [PERMISSION.SERVICES.CREATE],
			},
			{
				label: "Service detail",
				path: `${APP_PATH.services}/:id`,
				key: "",
				icon: <InfoOutlined />,
				children: [],
				component: <ServiceDetail />,
				hidden: true,
				permissions: [PERMISSION.SERVICES.VIEW],
			},
			//Service category
			{
				label: "Service categories",
				path: APP_PATH.serviceCategories,
				key: "service-categories",
				icon: <MenuOutlined />,
				children: [],
				component: <ServiceCategory />,
				permissions: [PERMISSION.SERVICE_CATEGORIES.VIEW],
			},
			{
				label: "Service category create",
				path: APP_PATH.serviceCategoryCreate,
				key: "service-category-create",
				icon: <MenuOutlined />,
				hidden: true,
				component: <ServiceCategoryCreate />,
				permissions: [PERMISSION.SERVICE_CATEGORIES.CREATE],
			},
			{
				label: "Service category detail",
				path: `${APP_PATH.serviceCategories}/:id`,
				key: "service-category-detail",
				icon: <MenuOutlined />,
				hidden: true,
				component: <ServiceCategoryDetail />,
				permissions: [PERMISSION.SERVICE_CATEGORIES.VIEW],
			},
		],
	},

	RequestServiceRoutes,

	// start survey answer routes
	{
		label: "Survey",
		path: APP_PATH.survey,
		key: "survey",
		children: [],
		icon: <EditOutlined />,
		component: <Surveys />,
		permissions: [PERMISSION.ANSWER_SURVEY.VIEW],
	},

	// end survey answer routes
	// Stores
	{
		label: "Store details",
		path: `${APP_PATH.merchants}/:merchantId/stores/:id`,
		key: "Store details",
		children: [],
		hidden: true,
		component: <StoreDetail />,
		permissions: [PERMISSION.CAR_STORE.VIEW],
	},
	{
		label: "Store create",
		path: `${APP_PATH.merchants}/:merchantId/stores/create`,
		key: "Store create",
		children: [],
		hidden: true,
		component: <StoreDetail />,
		permissions: [PERMISSION.CAR_STORE.CREATE],
	},
	{
		label: "Store details",
		path: `${APP_PATH.merchants}/stores/:id`,
		key: "store_detail_2",
		children: [],
		hidden: true,
		component: <StoreDetail />,
		permissions: [PERMISSION.CAR_STORE.VIEW],
	},

	// Affiliate routes
	...affiliateRoutes,

	// Community
	{
		label: "Community",
		path: "",
		key: "community",
		icon: <GlobalOutlined />,
		children: [
			{
				label: "Posts",
				path: APP_PATH.communityPosts,
				key: "postsCommunity",
				icon: <FormOutlined />,
				component: <CommunityPosts />,
				permissions: [PERMISSION.COMMUNITY.VIEW],
			},
			{
				label: "Post Detail",
				path: `${APP_PATH.communityPosts}/:id`,
				key: "",
				icon: <UsergroupAddOutlined />,
				component: <CommunityPost />,
				hidden: true,
				permissions: [PERMISSION.COMMUNITY.VIEW],
			},
			{
				label: "Post Create",
				path: APP_PATH.communityPostCreate,
				key: "",
				icon: <UsergroupAddOutlined />,
				component: <CommunityPost />,
				hidden: true,
				permissions: [PERMISSION.COMMUNITY.UPDATE],
			},
		],
	},
	// Rating & reviews
	RatingRoutes,
	// Loyalty
	{
		label: "Loyalty",
		path: "",
		key: "loyalty",
		icon: <TrophyOutlined />,
		children: [
			{
				label: "Campaigns",
				path: APP_PATH.loyaltyCampaigns,
				key: "campaigns",
				icon: <PlayCircleOutlined />,
				component: <LoyaltyCampaigns />,
				permissions: [PERMISSION.LOYALTY.VIEW],
			},
			{
				label: "Campaign Detail",
				path: `${APP_PATH.loyaltyCampaigns}/:id`,
				key: "",
				hidden: true,
				icon: <PlayCircleOutlined />,
				component: <LoyaltyCampaign />,
				permissions: [PERMISSION.LOYALTY.VIEW],
			},
			{
				label: "Campaign Create",
				path: APP_PATH.loyaltyCampaignCreate,
				key: "",
				hidden: true,
				icon: <PlayCircleOutlined />,
				component: <LoyaltyCampaign />,
				permissions: [PERMISSION.LOYALTY.UPDATE],
			},
			{
				label: "Vouchers",
				path: "",
				key: "vouchers",
				icon: <GiftOutlined />,
				permissions: [PERMISSION.LOYALTY.VIEW],
				children: [
					{
						label: "Customer",
						path: "",
						key: "customer",
						icon: <GiftOutlined />,
						children: [
							// Liberty vouncher
							{
								label: "Liberty's Vouchers",
								path: APP_PATH.loyaltyCustomerVouchersOfLiberty,
								key: "vouchers-of-liberty",
								icon: <GiftOutlined />,
								component: <LoyaltyCustomerVoucherOfLiberty />,
								permissions: [PERMISSION.LOYALTY.VIEW],
							},
							{
								label: "Details",
								path: `${APP_PATH.loyaltyCustomerVouchersOfLiberty}/:id`,
								key: "vouchers-of-liberty",
								icon: <GiftOutlined />,
								component: <LoyaltyVoucher />,
								hidden: true,
								permissions: [PERMISSION.LOYALTY.VIEW],
							},
							{
								label: "Create",
								path: APP_PATH.loyaltyCustomerVoucherOfLibertyCreate,
								key: "vouchers-of-liberty",
								icon: <GiftOutlined />,
								component: <LoyaltyVoucher />,
								hidden: true,
								permissions: [PERMISSION.LOYALTY.UPDATE],
							},

							// merchant vouncher
							{
								label: "Merchant's Vouchers",
								path: APP_PATH.loyaltyCustomerVouchersOfMerchant,
								key: "vouchers-of-merchant",
								icon: <GiftOutlined />,
								component: <LoyaltyCustomerVoucherOfMerhant />,
								permissions: [PERMISSION.LOYALTY.VIEW],
							},
							{
								label: "Details",
								path: `${APP_PATH.loyaltyCustomerVouchersOfMerchant}/:id`,
								key: "vouchers-of-merchant",
								icon: <GiftOutlined />,
								component: <LoyaltyVoucher />,
								hidden: true,
								permissions: [PERMISSION.LOYALTY.VIEW],
							},
						],
					},

					{
						label: "Merchant",
						path: APP_PATH.loyaltyVouchersMerchant,
						key: "merchantV",
						icon: <GiftOutlined />,
						component: <LoyaltyVouchersMerchant />,
						permissions: [PERMISSION.LOYALTY.VIEW],
					},
					{
						label: "Merchant",
						path: `${APP_PATH.loyaltyVouchersMerchant}/:id`,
						key: "merchant",
						icon: <GiftOutlined />,
						component: <LoyaltyVoucher />,
						permissions: [PERMISSION.LOYALTY.VIEW],
						hidden: true,
					},
					{
						label: "Create",
						path: APP_PATH.loyaltyVoucherMerchantCreate,
						key: "merchant",
						icon: <GiftOutlined />,
						component: <LoyaltyVoucher />,
						hidden: true,
						permissions: [PERMISSION.LOYALTY.UPDATE],
					},
				],
			},
		],
	},
	...auctionRoutes,
	...investmentRoutes,
	{
		label: "Webapp",
		path: APP_PATH.formRequest,
		key: "webapp",
		icon: <AppstoreOutlined />,
		children: [
			{
				label: "Investment request",
				key: "investment",
				component: <Investments />,
				path: APP_PATH.investment,
				icon: <BookOutlined />,
				permissions: [PERMISSION.RECRUITMENT.VIEW],
			},
			{
				label: "Investment Request Details",
				key: "",
				component: <FormRequestDetail />,
				path: `${APP_PATH.investment}/:id`,
				hidden: true,
				permissions: [
					PERMISSION.RECRUITMENT.VIEW,
					PERMISSION.RECRUITMENT.UPDATE,
				],
			},
			{
				label: "Recruitment",
				key: "recruitment",
				path: "",
				icon: <UserSwitchOutlined />,
				children: [
					{
						label: "Career Post",
						key: "postsCareer",
						path: `${APP_PATH.recruitmentCareerPosts}`,
						icon: <UserSwitchOutlined />,
						component: <CareerPosts />,
					},
					{
						label: "Career Post",
						key: "postsCreate",
						path: `${APP_PATH.recruitmentCareerPostsCreate}`,
						icon: <UserSwitchOutlined />,
						component: <CareerPostDetail />,
						hidden: true,
					},
					{
						label: "Career Post",
						key: "postsDetail",
						path: `${APP_PATH.recruitmentCareerPosts}/:id`,
						icon: <UserSwitchOutlined />,
						component: <CareerPostDetail />,
						hidden: true,
					},
					{
						label: "Candidate",
						key: "candidates",
						path: `${APP_PATH.recruitmentCandidates}`,
						icon: <UserSwitchOutlined />,
						component: <Candidates />,
					},
					{
						label: "Candidate",
						key: "candidates",
						path: `${APP_PATH.recruitmentCandidates}/:id`,
						icon: <UserSwitchOutlined />,
						component: <CandidateDetail />,
						hidden: true,
					},
				],
				permissions: [
					PERMISSION.RECRUITMENT.VIEW,
					PERMISSION.RECRUITMENT.UPDATE,
				],
			},
		],
		permissions: [
			PERMISSION.CUSTOMER_REQUEST.VIEW,
			PERMISSION.RECRUITMENT.VIEW,
		],
	},

	// App version
	{
		label: "App version",
		path: APP_PATH.appVersion,
		key: "app-version",
		icon: <DeploymentUnitOutlined />,
		children: [],
		component: <AppVersion />,
		permissions: [PERMISSION.APP_VERSION.VIEW],
	},
	// End app version

	// Master data
	materDataRoutes,
];

// Helper function to collect all unique permissions from children
const collectChildPermissions = (children: RouteEl[]): string[] => {
	const permissions = new Set<string>();

	children.forEach(child => {
		// Add child's direct permissions
		child.permissions = child.permissions || [];
		child.permissions.forEach(p => permissions.add(p));

		// Recursively collect permissions from grandchildren
		if (child.children && child.children.length > 0) {
			collectChildPermissions(child.children).forEach(p => {
				permissions.add(p);
				if (!child.permissions?.includes(p)) {
					child.permissions!.push(p);
				}
			});
		}
	});

	return Array.from(permissions);
};

// Update parent routes with child permissions
const mappedRoutes = routes.map(route => {
	if (route.children && route.children.length > 0) {
		const childPermissions = collectChildPermissions(route.children);
		return {
			...route,
			permissions: Array.from(
				new Set([...(route.permissions || []), ...childPermissions]),
			),
		};
	}
	return route;
});

export default mappedRoutes;
